import { render, staticRenderFns } from "./ChatOrderProfileAddressForm.vue?vue&type=template&id=cc565770&scoped=true&"
import script from "./ChatOrderProfileAddressForm.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileAddressForm.vue?vue&type=style&index=0&id=cc565770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc565770",
  null
  
)

export default component.exports